import './App.css';
import Header from './components/box_1';
import Footer from './components/box_3';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import Body from './components/box_2';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAFeXb_r9c35sXXB3rYKpVoKNysFwF-10I",
  authDomain: "tuanonthego.firebaseapp.com",
  projectId: "tuanonthego",
  storageBucket: "tuanonthego.appspot.com",
  messagingSenderId: "957880335414",
  appId: "1:957880335414:web:6a0537e6d746e7bdbc2c97",
  measurementId: "G-TWKSN92TLZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function App() {
  return (
    <div className="App ">
      <Header />
      <Body />
      <Footer />
    </div>
  );
}

export default App;
